export enum TransitionStateEnum {
  UNFOLDED_STEP_1 = "UNFOLDED_STEP_1",
  UNFOLDED_STEP_2 = "UNFOLDED_STEP_2",
  UNFOLDED_STEP_3 = "UNFOLDED_STEP_3",
  FOLDED_STEP_1 = "FOLDED_STEP_1",
  FOLDED_STEP_2 = "FOLDED_STEP_2",
  FOLDED_STEP_3 = "FOLDED_STEP_3",
  FOLDED_STEP_4 = "FOLDED_STEP_4",
  FOLDED_STEP_5 = "FOLDED_STEP_5",
}

export enum LockedStateEnum {
  LOCKED_FOLDED = "LOCKED_FOLDED",
  LOCKED_UP = "LOCKED_UP",
  LOCKED_UNFOLDED = "LOCKED_UNFOLDED",
  LOCKED_UNFOLDED_STEP_1 = "LOCKED_UNFOLDED_STEP_1",
  LOCKED_UNFOLDED_STEP_2 = "LOCKED_UNFOLDED_STEP_2",
  LOCKED_UNFOLDED_STEP_3 = "LOCKED_UNFOLDED_STEP_3",
  LOCKED_FOLDED_STEP_1 = "LOCKED_FOLDED_STEP_1",
  LOCKED_FOLDED_STEP_2 = "LOCKED_FOLDED_STEP_2",
  LOCKED_FOLDED_STEP_3 = "LOCKED_FOLDED_STEP_3",
  LOCKED_FOLDED_STEP_4 = "LOCKED_FOLDED_STEP_4",
  LOCKED_FOLDED_STEP_5 = "LOCKED_FOLDED_STEP_5",
  LOCKED_PAUSED_FOLDED = "LOCKED_PAUSED_FOLDED",
  LOCKED_PAUSED_UP = "LOCKED_PAUSED_UP",
  LOCKED_PAUSED_UNFOLDED = "LOCKED_PAUSED_UNFOLDED",
  LOCKED_PAUSED_UNFOLDED_STEP_1 = "LOCKED_PAUSED_UNFOLDED_STEP_1",
  LOCKED_PAUSED_UNFOLDED_STEP_2 = "LOCKED_PAUSED_UNFOLDED_STEP_2",
  LOCKED_PAUSED_UNFOLDED_STEP_3 = "LOCKED_PAUSED_UNFOLDED_STEP_3",
  LOCKED_PAUSED_FOLDED_STEP_1 = "LOCKED_PAUSED_FOLDED_STEP_1",
  LOCKED_PAUSED_FOLDED_STEP_2 = "LOCKED_PAUSED_FOLDED_STEP_2",
  LOCKED_PAUSED_FOLDED_STEP_3 = "LOCKED_PAUSED_FOLDED_STEP_3",
  LOCKED_PAUSED_FOLDED_STEP_4 = "LOCKED_PAUSED_FOLDED_STEP_4",
  LOCKED_PAUSED_FOLDED_STEP_5 = "LOCKED_PAUSED_FOLDED_STEP_5",
}

export enum PausedStateEnum {
  PAUSED_FOLDED = "PAUSED_FOLDED",
  PAUSED_UP = "PAUSED_UP",
  PAUSED_UNFOLDED = "PAUSED_UNFOLDED",
  PAUSED_UNFOLDED_STEP_1 = "PAUSED_UNFOLDED_STEP_1",
  PAUSED_UNFOLDED_STEP_2 = "PAUSED_UNFOLDED_STEP_2",
  PAUSED_UNFOLDED_STEP_3 = "PAUSED_UNFOLDED_STEP_3",
  PAUSED_FOLDED_STEP_1 = "PAUSED_FOLDED_STEP_1",
  PAUSED_FOLDED_STEP_2 = "PAUSED_FOLDED_STEP_2",
  PAUSED_FOLDED_STEP_3 = "PAUSED_FOLDED_STEP_3",
  PAUSED_FOLDED_STEP_4 = "PAUSED_FOLDED_STEP_4",
  PAUSED_FOLDED_STEP_5 = "PAUSED_FOLDED_STEP_5",
}

export enum NominalStateEnum {
  FOLDED = "FOLDED",
  UP = "UP",
  UNFOLDED = "UNFOLDED",
  ERROR = "ERROR",
  TIMEOUT = "TIMEOUT", //A remplacer pour un etat d'erreur avec precision timeout
}

export enum ModuleStateEnum {
  FOLDED = "FOLDED",
  UP = "UP",
  UNFOLDED = "UNFOLDED",
  ERROR = "ERROR",
  TIMEOUT = "TIMEOUT", //A remplacer pour un etat d'erreur avec precision timeout
  UNFOLDED_STEP_1 = "UNFOLDED_STEP_1",
  UNFOLDED_STEP_2 = "UNFOLDED_STEP_2",
  UNFOLDED_STEP_3 = "UNFOLDED_STEP_3",
  FOLDED_STEP_1 = "FOLDED_STEP_1",
  FOLDED_STEP_2 = "FOLDED_STEP_2",
  FOLDED_STEP_3 = "FOLDED_STEP_3",
  FOLDED_STEP_4 = "FOLDED_STEP_4",
  FOLDED_STEP_5 = "FOLDED_STEP_5",
  PAUSED_FOLDED = "PAUSED_FOLDED",
  PAUSED_UP = "PAUSED_UP",
  PAUSED_UNFOLDED = "PAUSED_UNFOLDED",
  PAUSED_UNFOLDED_STEP_1 = "PAUSED_UNFOLDED_STEP_1",
  PAUSED_UNFOLDED_STEP_2 = "PAUSED_UNFOLDED_STEP_2",
  PAUSED_UNFOLDED_STEP_3 = "PAUSED_UNFOLDED_STEP_3",
  PAUSED_FOLDED_STEP_1 = "PAUSED_FOLDED_STEP_1",
  PAUSED_FOLDED_STEP_2 = "PAUSED_FOLDED_STEP_2",
  PAUSED_FOLDED_STEP_3 = "PAUSED_FOLDED_STEP_3",
  PAUSED_FOLDED_STEP_4 = "PAUSED_FOLDED_STEP_4",
  PAUSED_FOLDED_STEP_5 = "PAUSED_FOLDED_STEP_5",
  WAITING_FOR_STATE = "WAITING_FOR_STATE",
  LOCKED_FOLDED = "LOCKED_FOLDED",
  LOCKED_UP = "LOCKED_UP",
  LOCKED_UNFOLDED = "LOCKED_UNFOLDED",
  LOCKED_UNFOLDED_STEP_1 = "LOCKED_UNFOLDED_STEP_1",
  LOCKED_UNFOLDED_STEP_2 = "LOCKED_UNFOLDED_STEP_2",
  LOCKED_UNFOLDED_STEP_3 = "LOCKED_UNFOLDED_STEP_3",
  LOCKED_FOLDED_STEP_1 = "LOCKED_FOLDED_STEP_1",
  LOCKED_FOLDED_STEP_2 = "LOCKED_FOLDED_STEP_2",
  LOCKED_FOLDED_STEP_3 = "LOCKED_FOLDED_STEP_3",
  LOCKED_FOLDED_STEP_4 = "LOCKED_FOLDED_STEP_4",
  LOCKED_FOLDED_STEP_5 = "LOCKED_FOLDED_STEP_5",
  LOCKED_PAUSED_FOLDED = "LOCKED_PAUSED_FOLDED",
  LOCKED_PAUSED_UP = "LOCKED_PAUSED_UP",
  LOCKED_PAUSED_UNFOLDED = "LOCKED_PAUSED_UNFOLDED",
  LOCKED_PAUSED_UNFOLDED_STEP_1 = "LOCKED_PAUSED_UNFOLDED_STEP_1",
  LOCKED_PAUSED_UNFOLDED_STEP_2 = "LOCKED_PAUSED_UNFOLDED_STEP_2",
  LOCKED_PAUSED_UNFOLDED_STEP_3 = "LOCKED_PAUSED_UNFOLDED_STEP_3",
  LOCKED_PAUSED_FOLDED_STEP_1 = "LOCKED_PAUSED_FOLDED_STEP_1",
  LOCKED_PAUSED_FOLDED_STEP_2 = "LOCKED_PAUSED_FOLDED_STEP_2",
  LOCKED_PAUSED_FOLDED_STEP_3 = "LOCKED_PAUSED_FOLDED_STEP_3",
  LOCKED_PAUSED_FOLDED_STEP_4 = "LOCKED_PAUSED_FOLDED_STEP_4",
  LOCKED_PAUSED_FOLDED_STEP_5 = "LOCKED_PAUSED_FOLDED_STEP_5",
}
